import Decimal from 'decimal.js';

import { isNumber } from './primitives';

// Custom implementation of Moving Average function which operates
// on really small numbers. It uses DecimalJS to perform basic
// arithmetic operations: plus, minus, div
export const ma = (data = [], period) => {
  const len = data.length;

  if (!len) {
    return data;
  }

  if (!isNumber(period)) {
    return data;
  }

  if (period === 0) {
    return data;
  }

  if (period > len) {
    return Array(len);
  }

  const res = [];
  let sum = new Decimal(0);

  for (let i = 0; i < len; i += 1) {
    const datum = data[i];

    if (isNumber(datum)) {
      sum = sum.plus(datum);
    }

    if (i < period - 1) {
      res.push(undefined);
    } else {
      const datumPrevious = data[i - period];

      if (isNumber(datumPrevious)) {
        sum = sum.minus(datumPrevious);
      }

      const v = sum.div(period).toNumber();
      res.push(v);
    }
  }

  return res;
};
